const {
  DASHBOARD_ANALYTICS_REQUEST,
  DASHBOARD_ANALYTICS_SUCCESS,
  DASHBOARD_ANALYTICS_FAILURE,
  SET_MY_JOBS_FILTERS,
  SET_MY_JOBDATA,
  SET_INPROGRESS_CHART_CLICKED_DATA,
  SET_TICKET_TILE,
  FETCH_MY_JOBS_REQUEST,
  FETCH_MY_JOBS_SUCCESS,
  FETCH_MY_JOBS_FAIL,
  SET_AGEPROFILE_CHART_CLICKED_DATA,
  SET_MENUE,
  SET_ROW_ID,
  REMOVE_ROW_ID,
  SET_COMPLIANCE_TILE,
  SET_ACTIVE_PANEL,
  SET_ROW_SIZE,
  ARCHIVED_TICKET_FILTER_SET,
  SET_ARCHIVED_MONTHS,
  FETCH_ARCHIVED_JOBS_FAIL,
  FETCH_ARCHIVED_JOBS_REQUEST,
  FETCH_ARCHIVED_JOBS_SUCCESS,
  UPDATE_ACTIVITY_VIEW_REQUEST,
  UPDATE_ACTIVITY_VIEW_SUCCESS,
  UPDATE_ACTIVITY_VIEW_FAIL,
  FETCH_DROPDOWN_DATA_REQUEST,
  FETCH_LISTINGS_SUCCESS,
  FETCH_TRADESPERSONS_SUCCESS,
  FETCH_LANDLORDS_SUCCESS,
  FETCH_PRIMARY_CONTACTS_SUCCESS,
  FETCH_TRADESPERSON_LISTINGS_SUCCESS,
  FETCH_DROPDOWN_DATA_FAIL,
  FETCH_DROPDOWN_DATA_SUCCESS,
  CLEAR_DROPDOWN_DATA
} = require("./types");

const initialState = {
  analytics: {},
  loading: false,
  feedLoading: false,
  filters: {
    status: "",
    property: "",
    tradesPerson: "",
    landlord: "",
    primaryContact: "",
    // My Jobs pillar - "" reads as Repairs (pillarOf in _shared/jobType.js).
    jobType: "",
    // Landlord-side My Jobs stage - "" is All (open jobs).
    stage: "",
    // Landlord-side closed-jobs period (MyJobsClosedPeriod) - "" shows open jobs.
    closedPeriod: "",
    // One compliance automation run's tasks ("View tasks" in its run history).
    complianceRunId: ""
  },
  tickets: [],
  archivedData: {
    archivedTickets: [],
    months: 0,
    isFilterChanged: false,
    isfetched: false,
    loading: false
  },
  inProgressClickedData: null,
  ageProfileClickedData: null,
  ticketTile: null,
  currentMenue: JSON.parse(localStorage.getItem("current-menue")) || "/Dashboard",
  isDetail: false,
  complianceTile: null,
  ticketActivePanel: 0,
  viewTicketId: "",
  viewTicketsPageCount: 25,
  archivedTicketFilter: null,
  pagination: null,
  metadata: null,
  FilterDropDown: {
    validationError: false,
    property: [],
    isfetched: false,
    filterLoading: false,
    landlord: [],
    tradesPerson: [],
    tradespersonsCachedAt: null,
    primaryContact: [],
    primaryContactCacheTimestamp: null,
    tradespersonListingsCacheTimestamp: null
  }
};
const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_ANALYTICS_REQUEST:
    case FETCH_MY_JOBS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case FETCH_ARCHIVED_JOBS_REQUEST:
      return {
        ...state,
        archivedData: {
          ...state.archivedData,
          loading: true,
          archivedTickets: [],
          isfetched: false
        }
      };
    case UPDATE_ACTIVITY_VIEW_REQUEST:
      return {
        ...state,
        feedLoading: true
      };
    case UPDATE_ACTIVITY_VIEW_SUCCESS:
      return {
        ...state,
        feedLoading: false,
        analytics: { ...state.analytics, ...action.payload }
      };
    case SET_ACTIVE_PANEL:
      return {
        ...state,
        ticketActivePanel: action.payload
      };
    case DASHBOARD_ANALYTICS_SUCCESS:
      return {
        ...state,
        analytics: action.payload,
        loading: false
      };
    case FETCH_MY_JOBS_SUCCESS: {
      // Support both old format (array) and new format (object with tickets, pagination, metadata)
      const isNewFormat = action.payload && typeof action.payload === "object" && !Array.isArray(action.payload) && "tickets" in action.payload;
      const ticketsArray = isNewFormat
        ? (Array.isArray(action.payload.tickets) ? action.payload.tickets : [])
        : Array.isArray(action.payload)
          ? action.payload
          : [];
      return {
        ...state,
        tickets: ticketsArray,
        pagination: isNewFormat ? action.payload.pagination : null,
        metadata: isNewFormat ? action.payload.metadata : null,
        loading: false
      };
    }
    case FETCH_ARCHIVED_JOBS_SUCCESS: {
      // Support both new format (with pagination) and old format (array) for backward compatibility
      // action.payload structure: { tickets: [...], pagination: {...}, metadata: {...}, months: 12 }
      const isNewFormat =
        action.payload &&
        typeof action.payload === "object" &&
        action.payload.tickets &&
        Array.isArray(action.payload.tickets) &&
        action.payload.pagination;
      const archivedTickets = isNewFormat ? action.payload.tickets : Array.isArray(action.payload.tickets) ? action.payload.tickets : [];
      return {
        ...state,
        archivedData: {
          archivedTickets: archivedTickets,
          months: action.payload.months,
          isfetched: true,
          loading: false
        },
        // Store tickets, pagination and metadata for archived jobs (same as regular jobs)
        tickets: archivedTickets,
        pagination: isNewFormat ? action.payload.pagination : null,
        metadata: isNewFormat ? action.payload.metadata : null
      };
    }
    case DASHBOARD_ANALYTICS_FAILURE:
    case FETCH_MY_JOBS_FAIL:
      return {
        ...state,
        loading: false
      };
    case FETCH_ARCHIVED_JOBS_FAIL:
      return {
        ...state,
        archivedData: {
          ...state.archivedData,
          loading: false,
          isfetched: false,
          archivedTickets: []
        }
      };
    case UPDATE_ACTIVITY_VIEW_FAIL:
      return {
        ...state,
        feedLoading: false
      };
    case SET_MY_JOBS_FILTERS: {
      return {
        ...state,
        filters: action.payload.filters,
        FilterDropDown: {
          ...state.FilterDropDown,
          validationError: action.payload.validation
        },
        archivedData: {
          ...state.archivedData,
          isFilterChanged: true
        }
      };
    }
    case SET_MY_JOBDATA:
      return {
        ...state,
        tickets: action.payload
      };

    case SET_INPROGRESS_CHART_CLICKED_DATA:
      return {
        ...state,
        inProgressClickedData: action.payload
      };
    case SET_AGEPROFILE_CHART_CLICKED_DATA:
      return {
        ...state,
        ageProfileClickedData: action.payload
      };
    case SET_TICKET_TILE:
      return {
        ...state,
        ticketTile: action.payload
      };
    case SET_MENUE:
      localStorage.setItem("current-menue", JSON.stringify(action.payload.path));
      return {
        ...state,
        currentMenue: action.payload.path,
        isDetail: action.payload.isDetail ? action.payload.isDetail : false
      };
    case SET_ROW_ID:
      return {
        ...state,
        viewTicketId: action.payload
      };
    case SET_ROW_SIZE:
      return {
        ...state,
        viewTicketsPageCount: action.payload
      };
    case REMOVE_ROW_ID:
      return {
        ...state,
        viewTicketId: ""
      };
    case SET_COMPLIANCE_TILE:
      return {
        ...state,
        complianceTile: action.payload
      };
    case ARCHIVED_TICKET_FILTER_SET: {
      return {
        ...state,
        archivedTicketFilter: action.payload
      };
    }
    case SET_ARCHIVED_MONTHS: {
      return {
        ...state,
        archivedData: {
          ...state.archivedData,
          months: action.payload,
          isFilterChanged: false // Reset filter changed flag when months change
        }
      };
    }
    case FETCH_DROPDOWN_DATA_REQUEST:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          filterLoading: true,
          isfetched: false
        }
      };

    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          property: action.payload
        }
      };

    case FETCH_TRADESPERSONS_SUCCESS: {
      const payload = action.payload;
      const data = Array.isArray(payload) ? payload : payload?.data;
      const timestamp = (payload && typeof payload === "object" && "timestamp" in payload) ? payload.timestamp : Date.now();
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          tradesPerson: data ?? payload,
          tradespersonsCachedAt: timestamp
        }
      };
    }

    case FETCH_LANDLORDS_SUCCESS:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          landlord: action.payload
        }
      };

    case FETCH_PRIMARY_CONTACTS_SUCCESS:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          primaryContact: action.payload.data,
          primaryContactCacheTimestamp: action.payload.timestamp
        }
      };

    case FETCH_TRADESPERSON_LISTINGS_SUCCESS:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          property: action.payload.data,
          tradespersonListingsCacheTimestamp: action.payload.timestamp
        }
      };

    case FETCH_DROPDOWN_DATA_SUCCESS:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          filterLoading: false,
          isfetched: true,
          validationError: action.payload
        },
        archivedData: {
          ...state.archivedData,
          isFilterChanged: false
        }
      };

    case FETCH_DROPDOWN_DATA_FAIL:
      return {
        ...state,
        FilterDropDown: {
          ...state.FilterDropDown,
          filterLoading: false,
          isfetched: false
        },
        error: action.payload
      };
    case CLEAR_DROPDOWN_DATA: {
      return {
        ...state,
        archivedData: {
          ...state.archivedData,
          months: 0,
          isfetched: false,
          archivedTickets: [],
          loading: false
        }
      };
    }
    default:
      return state;
  }
};

export default analyticsReducer;
